import type { Product, ProductType } from '../state/types'
import { formatJPY } from './format'

function normalizeDigits(value: string): string {
  return value.replace(/[０-９]/g, (char) => String(char.charCodeAt(0) - 0xff10))
}

export function sanitizePriceInput(value: string): string {
  return normalizeDigits(value).replace(/[^\d]/g, '')
}

export function parsePriceInputJPY(value: string): number {
  const normalized = sanitizePriceInput(value)
  if (!normalized) return 0

  return Math.floor(Number(normalized) || 0)
}

export function inferProductTypeFromName(name: string): ProductType {
  const normalized = name.trim().toLowerCase()

  if (
    normalized.includes('ホテル') ||
    normalized.includes('会員権') ||
    normalized.includes('j ホテルズ') ||
    normalized.includes('jホテルズ')
  ) {
    return 'hotel_membership'
  }

  if (normalized.includes('広告')) {
    return 'ad_slot'
  }

  return 'signage'
}

export function getProductPriceLabel(product: Pick<Product, 'priceLabel' | 'listPriceJPY'>): string {
  if (product.listPriceJPY > 0) return formatJPY(product.listPriceJPY)
  return '価格未設定'
}

export function isAdSlotProduct(product: Pick<Product, 'type'>): boolean {
  return product.type === 'ad_slot'
}
